import { gql } from '@src/__generated__';

export const CREATE_NOTIFICATION = gql(/* GraphQL */ `
  mutation sendNotification($input: CreateNotificationInput!) {
    createNotification(input: $input) {
      clientMutationId
    }
  }
`);
